<template>
  <div class="error-box blue-grey lighten-5">
    <div class="py-12">
      <div class="text-center">
        <h1 class="error-title red--text text--lighten-1">403</h1>
        <h3 class="text-uppercase error-subtitle white--text">
          Not Authorized
        </h3>
        <p class="text-muted mt-4 mb-4 white--text" v-if="codeDetail">
          <span v-html="codeDetail"></span>
        </p>
        <p class="text-muted mt-4 mb-4 white--text" v-if="codeNum">
          CODE{{ codeNum }}
        </p>
        <p class="text-muted mt-4 mb-4 grey--text caption">
          If this page is displayed for no reason, please relaunch after all
          signouts and close browsers.
        </p>
        <v-btn @click="gotoHandler">Home</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
// import store from "../../store";
export default {
  name: "Error",
  data: () => ({}),
  computed: {
    codeNum: function() {
      let rtn;
      if (this.$route.params && this.$route.params.code == "who") rtn = "001";
      if (this.$route.params && this.$route.params.code == "when") rtn = "002";
      if (this.$route.params && this.$route.params.code == "where") rtn = "003";
      return rtn;
    },
    codeDetail: function() {
      let rtn;
      if (this.$route.params && this.$route.params.code == "who") rtn = "001";
      if (this.$route.params && this.$route.params.code == "when") rtn = "002";
      if (this.$route.params && this.$route.params.code == "where") rtn = "003";
      if (this.$route.params && this.$route.params.code == "block")
        rtn =
          "The same app was launched in another window. <br>Please use it in one window.";
      if (this.$route.params && this.$route.params.code == "offline")
        rtn =
          "The app was duplicated in other browsers. <br>Please use it in one browser.";
      return rtn;
    }
  },
  methods: {
    gotoHandler: async function() {
      this.$router.push({
        path: "/"
      });
    }
  },
  async mounted() {
    const code = this.$route.params ? this.$route.params.code : undefined;
    if (code != "block") {
      await this.$store.dispatch("signOut", "stay");
    }
    console.log(this.$route.params);
  }
};
</script>

<style lang="scss">
.error-box {
  height: 100%;
  width: 100%;
  position: fixed;
  background-position: top center;
  background-repeat: no-repeat;
  background: url("../../assets/images/background/error-bg.jpg");
}
.error-title {
  font-size: 210px;
  font-weight: 900;
  //text-shadow: 4px 4px 0 #fff, 6px 6px 0 #343a40;
  line-height: 210px;
}

@media (max-width: 991px) {
  .error-title {
    font-size: 120px;
    line-height: 120px;
  }
}

@media (max-width: 767px) {
  .error-title {
    font-size: 40px;
    line-height: 40px;
  }
}
</style>
